// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/MajorItem/index.less
// module id = 413
// module chunks = 0